import React from 'react';
import Create from 'containers/rest/Create';
import Form from '../components/Form';

const CareerRequestsCreate = props => (
  <Create {...props} resource="careerRequests">
    <Form />
  </Create>
);

CareerRequestsCreate.propTypes = {};

export default CareerRequestsCreate;
